import * as React from 'react';
import {
  Wrapper,
  LogoContainer,
  Container,
  CampusContainer,
  UniversityInfo,
} from './UniversityBio.styles';
import type { UniversityBioProps } from './UniversityBio.types';

export const UniversityBio = ({
  name,
  logo,
  campusImage,
  text,
}: UniversityBioProps): React.ReactElement<any> => (
  <Wrapper>
    <Container>
      <LogoContainer>
        <img src={logo} alt={`${name} logo`} loading='lazy' width='100%' height='100%' />
      </LogoContainer>
      <UniversityInfo>{text}</UniversityInfo>
    </Container>
    <CampusContainer>
      <img src={campusImage} alt='University campus' loading='lazy' width='100%' height='100%' />
    </CampusContainer>
  </Wrapper>
);
